const nameOf = (predicate)=>{
    var _ref, _ref1, _ref2;
    var _predicate_name, _predicate_name1, _predicate_name2, _predicate_name3;
    return (_ref = (_ref1 = (_ref2 = predicate === null || predicate === void 0 ? void 0 : (_predicate_name = predicate.name) === null || _predicate_name === void 0 ? void 0 : _predicate_name.exact) !== null && _ref2 !== void 0 ? _ref2 : predicate === null || predicate === void 0 ? void 0 : (_predicate_name1 = predicate.name) === null || _predicate_name1 === void 0 ? void 0 : _predicate_name1.contains) !== null && _ref1 !== void 0 ? _ref1 : predicate === null || predicate === void 0 ? void 0 : (_predicate_name2 = predicate.name) === null || _predicate_name2 === void 0 ? void 0 : _predicate_name2.fuzzy) !== null && _ref !== void 0 ? _ref : predicate === null || predicate === void 0 ? void 0 : (_predicate_name3 = predicate.name) === null || _predicate_name3 === void 0 ? void 0 : _predicate_name3.startsWith;
};
export const serviceNamesToSet = (service)=>{
    var _service_or;
    const fromArms = ((_service_or = service.or) !== null && _service_or !== void 0 ? _service_or : []).map((arm)=>nameOf(arm)).filter((name)=>name != null);
    const single = nameOf(service);
    return {
        in: [
            ...new Set([
                ...single != null ? [
                    single
                ] : [],
                ...fromArms
            ])
        ]
    };
};
